// Config
import paymentTypeConstants from './paymentTypeConstants';
import supportedCreditCardTypes from './supportedCreditCardTypes';

// Design System
import amexLogo from 'jl-design-system/assets/third-party/payment-options/amex-large.svg';
import applePayLogo from 'jl-design-system/assets/third-party/payment-options/applepay-large.svg';
import buyNowPayLaterLogo from 'jl-design-system/assets/third-party/payment-options/buy-now-pay-later-large.svg';
import googlePayLogo from 'jl-design-system/assets/third-party/payment-options/googlepay-large.svg';
import johnLewisMoneyLogo from 'jl-design-system/assets/third-party/payment-options/john-lewis-money-large.svg';
import klarnaLogo from 'jl-design-system/assets/third-party/payment-options/klarna-large.svg';
import mastercardLogo from 'jl-design-system/assets/third-party/payment-options/mastercard-large.svg';
import partnership2022Logo from 'jl-design-system/assets/third-party/payment-options/partnership-card-large.svg';
import paypalLogo from 'jl-design-system/assets/third-party/payment-options/paypal-large.svg';
import visaLogo from 'jl-design-system/assets/third-party/payment-options/visa-large.svg';

const paymentLogoConstants: Record<string, string> = {
  [paymentTypeConstants.APPLE_PAY]: applePayLogo,
  [paymentTypeConstants.APPLE_PAY_EXPRESS]: applePayLogo,
  [paymentTypeConstants.GOOGLE_PAY]: googlePayLogo,
  [paymentTypeConstants.KLARNA]: klarnaLogo,
  [paymentTypeConstants.PAYPAL]: paypalLogo,
  [paymentTypeConstants.PAYPAL_EXPRESS]: paypalLogo,
  [paymentTypeConstants.PAYPAL_PAY_LATER]: paypalLogo,
  [paymentTypeConstants.POS_CREDIT]: johnLewisMoneyLogo,
  [supportedCreditCardTypes.AMERICAN_EXPRESS]: amexLogo,
  [supportedCreditCardTypes.MAESTRO]: mastercardLogo,
  [supportedCreditCardTypes.MASTERCARD]: mastercardLogo,
  [supportedCreditCardTypes.ANY_DAY]: mastercardLogo,
  [supportedCreditCardTypes.NEW_DAY]: partnership2022Logo,
  [supportedCreditCardTypes.VISA]: visaLogo,
  [supportedCreditCardTypes.VISA_DEBIT]: visaLogo,
  paymentHoliday: buyNowPayLaterLogo,
};

export default paymentLogoConstants;
